@if (!isMobileLayout$()) {
  <ng-container [ngTemplateOutlet]="vehicleTitleColumn"></ng-container>
  <td class="sticky-col second-col">
    @if (showListViewActionsDropdown) {
      <ng-container [ngTemplateOutlet]="actionsDropdown"></ng-container>
    }
  </td>
  @if (!isVehicleTypeFilterISV) {
    <td class="shadow-col"></td>
    <ng-container [ngTemplateOutlet]="offersColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="questionsColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="statusColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="highestOfferColumn"></ng-container>
    @if (showHistoricalHigh) {
      <ng-container [ngTemplateOutlet]="historicalHighColumn"></ng-container>
    }
    <ng-container [ngTemplateOutlet]="buyNowColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="openingPriceColumn"></ng-container>
    @if (showSaleFeeAndSalePriceColumn) {
      <ng-container [ngTemplateOutlet]="saleFeeColumn"></ng-container>
    }
    @if (showSaleFeeAndSalePriceColumn) {
      <ng-container [ngTemplateOutlet]="salePriceColumn"></ng-container>
    }
    @if (showTotalPriceColumn) {
      <ng-container [ngTemplateOutlet]="totalPriceColumn"></ng-container>
    }
    <td class="shadow-col-end"></td>
  } @else {
    <td class="shadow-col"></td>
    <ng-container [ngTemplateOutlet]="statusColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="groundedColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="locationColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="openingPriceColumn"></ng-container>
    <ng-container [ngTemplateOutlet]="odometerColumn"></ng-container>
    <td class="shadow-col-end"></td>
  }
}


@if (isMobileLayout$()) {
  <div class="mobile-list-view-item">
    <div class="mobile-header">
      @if (showListViewCheckbox) {
        <span class="custom-control custom-checkbox me-2">
          <input
            type="checkbox"
            class="custom-control-input"
            [id]="'action-bar-checkbox_' + auctionItemSell$()?.auctionItemUuid"
            (click)="toggleSelected()"
            [checked]="isVehicleSelected$()"
            [disabled]="disableActionBarCheckbox"
            >
          <label class="custom-control-label" [for]="'action-bar-checkbox_' + auctionItemSell$()?.auctionItemUuid"></label>
        </span>
      }
      <span [ngClass]="showListViewCheckbox ? 'mobile-list-view-inner-checkbox full-width' : 'mobile-list-card-inner full-width'">
        <div class="mobile-title">
          <a
            data-track-elem="card id"
            [attr.data-track-name]="auctionItemSell$()?.inventoryItemUuid + ' - MD' "
            routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/details"
            [state]="{ fromSearch: true }"
            [attr.aria-label]="title"
            [attr.allytmln]="auctionItemSell$()?.inventoryItemUuid + ' - MD' "
            (click)="updateBackToInventory()"
            >
            <strong>{{title}}</strong>
          </a>
        </div>
        <div class="vin-and-stock-num mobile_header_data full-width">
          <span>{{auctionItemSell$()?.itemDetail?.vin}}</span>
          <span class="mobile-header-data-row full-width mobile-no-overflow">
            <span>
              <span class="list-card-label no-left-margin">{{listViewTableTranslations.textStockUnitNumber}}</span>
              <span>{{(auctionItemSell$()?.itemDetail?.stockNumber ? auctionItemSell$().itemDetail.stockNumber : 'N/A') | uppercase}}</span>
            </span>
            @if (isInspectionSeriesEnabled) {
              <span class="inspection-series-mobile">
                <span class="list-card-label">{{listViewTableTranslations.textInspectionSeriesLabel}}</span>
                <span>{{(auctionItemSell$()?.inspectionSeries ? auctionItemSell$().inspectionSeries : 'N/A') | uppercase}}</span>
              </span>
            }
          </span>
        </div>
      </span>
    </div>
    <div class="mobile-info">
      <span class="mobile-col">
        @if (auctionItemStatusEqualTo(vehicleStatusFilter.ACTIVE)) {
          <ng-container [ngTemplateOutlet]="mobileHighestOfferField"></ng-container>
          @if (showHistoricalHigh) {
            <div class="pt-2" [ngTemplateOutlet]="mobileHistoricalHighField"></div>
          }
          <div class="pt-2" [ngTemplateOutlet]="mobileOpeningPriceField"></div>
        }
        @if (auctionItemStatusEqualTo(vehicleStatusFilter.SOLD)) {
          <ng-container [ngTemplateOutlet]="mobileSaleFeeField"></ng-container>
        }
      </span>
      <span class="mobile-col">
        @if (auctionItemStatusEqualTo(vehicleStatusFilter.ACTIVE)) {
          <ng-container [ngTemplateOutlet]="mobileSalePriceField"></ng-container>
          <div class="pt-2" [ngTemplateOutlet]="mobileBuyNowField"></div>
        }
        @if (auctionItemStatusEqualTo(vehicleStatusFilter.SOLD)) {
          <ng-container [ngTemplateOutlet]="mobileSalePriceField"></ng-container>
        }
      </span>
    </div>
    <span class="card__actions">
      <span class="card__actions-inner">
        <span class="mobile-row">
          <span class="card__actions-inner__indicator" [ngClass]="getStatusIndicatorClass()">
            <lib-state-indicator [identifier]="'inventory_block_status_' + index$()" [variant]="status.variant"></lib-state-indicator>
          </span>
          <div class="card__actions-inner__status d-flex">
            @if (auctionItemStatusEqualTo(vehicleStatusFilter.ACTIVE)) {
              <span class="mobile-row">
                <span class="status_offers_questions" [ngClass]="getBidStatusClasses()">
                  <a
                    href="#"
                    data-track-elem="button"
                    [attr.data-track-name]="'Offers-' + auctionItemSell$()?.inventoryItemUuid"
                    class="action ms-2"
                    [attr.allytmln]="'listOffers' + auctionItemSell$().openOfferCount"
                    (click)="updateBackToInventory()"
                    routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/offers"
                    >
                    <strong>{{listViewTableTranslations.textOffers}}</strong>
                    <span offers-badge>
                      @if (openOfferCount > 0) {
                        <span class="action-badge offers-badge">{{ openOfferCount }}</span>
                      }
                    </span>
                  </a>
                  <span class="divider">|</span>
                  <a
                    href="#"
                    data-track-elem="button"
                    [attr.data-track-name]="'Questions-' + auctionItemSell$()?.inventoryItemUuid"
                    class="action"
                    [attr.allytmln]="'listQuestions' + auctionItemSell$().openQuestionCount"
                    (click)="updateBackToInventory()"
                    routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/questions"
                    >
                    <strong>{{listViewTableTranslations.textQuestions}}</strong>
                    @if (openQuestionCount > 0) {
                      <div class="action-badge questions-badge">
                        {{ openQuestionCount }}
                      </div>
                    }
                  </a>
                  @if (isSellUpdateInventoryFeatureEnabled) {
                    <span>
                      <span class="divider">|</span>
                      <a
                        data-track-elem="button"
                        [class]="isEditDisabled ? 'action__disabled' : 'action'"
                        (click)=isEditCutOffTime()
                        [ngClass]="{'disableEdit':isEditDisabled,'enableEdit':!isEditDisabled}"
                        allytmln="sellEdit"
                        tabindex="0">
                        <strong>{{listViewTableTranslations.textEdit}}</strong>
                      </a>
                    </span>
                  }
                </span>
              </span>
            }
          </div>
          @if (showListViewActionsDropdown) {
            <ng-container [ngTemplateOutlet]="actionsDropdown"></ng-container>
          }
        </span>
      </span>
    </span>
  </div>
}

<ng-template #vehicleTitleColumn>
  <td class="sticky-col first-col">
    <div class="vehicle-list-card">
      <span class="status-indicator" [ngClass]="getStatusIndicatorClass()">
        <lib-state-indicator [identifier]="'inventory_block_status_' + index$()" [variant]="status.variant"></lib-state-indicator>
      </span>
      @if (showListViewCheckbox) {
        <div class="custom-control custom-checkbox ms-2">
          <input
            type="checkbox"
            class="custom-control-input"
            [id]="'action-bar-checkbox_' + auctionItemSell$()?.auctionItemUuid"
            (click)="toggleSelected()"
            [checked]="isVehicleSelected$()"
            [disabled]="disableActionBarCheckbox"
            >
          <label class="custom-control-label" [for]="'action-bar-checkbox_' + auctionItemSell$()?.auctionItemUuid"></label>
        </div>
      }
      <div [ngClass]="showListViewCheckbox ? 'vehicle-list-card-inner-checkbox' : 'vehicle-list-card-inner'">
        <a
          data-track-elem="card id"
          [attr.data-track-name]="auctionItemSell$()?.inventoryItemUuid + ' - MD' "
          routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/details"
          [state]="{ fromSearch: true }"
          [attr.aria-label]="title"
          [attr.allytmln]="auctionItemSell$()?.inventoryItemUuid + ' - MD' "
          (click)="updateBackToInventory()"
          >
          <strong>{{title}}</strong>
        </a>
        <div class="vin-and-stock-num data-row">
          <span class="stacked-label-and-data vin-container">
            <span class="row-header-data-label left-align no-margin">{{listViewTableTranslations.textVin}}</span>
            <span class="left-align bold no-margin">{{auctionItemSell$()?.itemDetail?.vin}}</span>
          </span>
          <span class="stacked-label-and-data stock-number">
            <span class="list-card-label left-align">{{listViewTableTranslations.textStockUnitNumber}}</span>
            <span class="left-align">{{(auctionItemSell$()?.itemDetail?.stockNumber ? auctionItemSell$().itemDetail.stockNumber : 'N/A') | uppercase}}</span>
          </span>
          @if (isInspectionSeriesEnabled) {
            <span class="stacked-label-and-data">
              <span class="list-card-label left-align">{{listViewTableTranslations.textInspectionSeriesLabel}}</span>
              <span class="left-align">{{(auctionItemSell$()?.inspectionSeries ? auctionItemSell$().inspectionSeries : 'N/A') | uppercase}}</span>
            </span>
          }
        </div>
      </div>
    </div>
  </td>
</ng-template>

<ng-template #actionsDropdown>
  <div class="ellipsis">
    <div class="dropdown">
      <trap-focus [enableFocusTrap]="isPopoverOpen" [focusOnFirstElem]="true">


        <button class="ellipsis_button" [popover]="actionsModal" #kabobPopOver="bs-popover" [placement]="isMobileLayout$() ? 'left' : 'right'"
          container="body" containerClass="list-view-actions-popover" [adaptivePosition]="true"
          triggers="click :keydown.escape :keydown.tab: keydown.enter" [outsideClick]="true" aria-label="ellipsis button"
          (onShown)="setIsPopoverOpen(true)"
          (onHidden)="setIsPopoverOpen(false)"
          [attr.aria-expanded]="isPopoverOpen"
          allytmln="List View Ellipses"
          aria-haspopup="true">
          <div class="dot" aria-label="ellipsis dot" role="dialog"></div>
          <div class="dot" aria-label="ellipsis dot" role="dialog"></div>
          <div class="dot" aria-label="ellipsis dot" role="dialog"></div>

          <ng-template #actionsModal>
            <div cdkTrapFocus [cdkTrapFocusAutoCapture]="false" #popoverContent>
              <button id="close_x_button" class="modal__close-btn"
                [attr.aria-label]=listViewTableTranslations.textClose data-track-elem="icon" data-track-name="close"
                data-track-trigger="close" (click)="closePopover()" title="close x button">
                <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
              </button>

              @if (isInServiceVehicleOrReservationsEnabled) {
                <ng-content *ngTemplateOutlet="inServiceVehicleButtons"></ng-content>
              }

              @if (!isInServiceVehicleOrReservationsEnabled) {
                @if (auctionItemStatusEqualTo(vehicleStatusFilter.ACTIVE)) {
                  <ng-content *ngTemplateOutlet="listViewActiveAuctionButtons"></ng-content>
                }
                @if (auctionItemStatusEqualTo(vehicleStatusFilter.SOLD)) {
                  <ng-content *ngTemplateOutlet="listViewHistoryButton"></ng-content>
                }
                @if (auctionItemStatusEqualTo(vehicleStatusFilter.HOLD)) {
                  <ng-content *ngTemplateOutlet="listViewEditButton"></ng-content>
                }
                @if (auctionItemStatusEqualTo(vehicleStatusFilter.REMOVED) || auctionItemStatusEqualTo(vehicleStatusFilter.EXPIRED)) {
                  <ng-content *ngTemplateOutlet="listViewPostingHistoryButton"></ng-content>
                  <ng-content *ngTemplateOutlet="listViewRepostButton"></ng-content>
                }
              }
            </div>
          </ng-template>
        </button>
      </trap-focus>
    </div>
  </div>
</ng-template>

<ng-template #offersColumn>
  @if (showOffersValue) {
    <td>
      <a
        href="#"
        data-track-elem="button"
        [attr.data-track-name]="'Offers-' + auctionItemSell$().inventoryItemUuid"
        class="action"
        (click)="updateBackToInventory()"
        [attr.allytmln]="'listOffers' + auctionItemSell$().openOfferCount"
        routerLink="/inventory/{{ auctionItemSell$().inventoryItemUuid }}/offers"
        >
        <strong>{{getAuctionItemOfferCount}}</strong>
      </a>
    </td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #questionsColumn>
  @if (showQuestionsValue) {
    <td>
      <a
        href="#"
        data-track-elem="button"
        [attr.data-track-name]="'Questions-' + auctionItemSell$().inventoryItemUuid"
        class="action"
        (click)="updateBackToInventory()"
        [attr.allytmln]="'listQuestions' + auctionItemSell$().openQuestionCount"
        routerLink="/inventory/{{ auctionItemSell$().inventoryItemUuid }}/questions"
        >
        <strong>{{openQuestionCount}}</strong>
      </a>
    </td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #statusColumn>
  @if (isReservedStatusFilter) {
    <td>
      {{auctionItemSell$().reservation?.reservedForDealerName}}
    </td>
  }
  @if (!isReservedStatusFilter) {
    <td>
      {{auctionItemSell$().auctionItemStatus}}
    </td>
  }
</ng-template>

<ng-template #locationColumn>
  <td>
    {{formatStorageLocation()}}
  </td>
</ng-template>

<ng-template #odometerColumn>
  <td>
    {{auctionItemSell$().itemDetail.odometer | number}}
  </td>
</ng-template>

<ng-template #highestOfferColumn>
  @if (showHighestOfferValue) {
    <td>{{highestOfferValue}}</td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #historicalHighColumn>
  <td data-test-id="app-list-view-inventory-item-historical-high-value">
    {{historicalHighValue}}
  </td>
</ng-template>

<ng-template #buyNowColumn>
  @if (showBuyNowValue) {
    <td>{{buyNowAmountValue}}</td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #openingPriceColumn>
  @if (showOpeningPriceValue) {
    <td>{{openingPriceValue}}</td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #saleFeeColumn>
  @if (showSaleFeeAndSalePriceValue) {
    <td>
      {{sellFeesTotalAmountValue}}
      @if (sellFeeTooltip) {
        <span>
          <app-tooltip [tooltip]="sellFeeDetailsTooltip" [showToolTipAsHtml]="true"
            triggers="click :keydown.escape :keydown.tab"
            (click)="analyticsInfo('Sell Fee Details')"
            allytmln="Sell Fee Details">
            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
          </app-tooltip>
        </span>
      }
    </td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #salePriceColumn>
  @if (showSaleFeeAndSalePriceValue) {
    <td>{{salePriceValue}}</td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #totalPriceColumn>
  @if (showTotalPriceValue && showTotalPriceColumn) {
    <td>
      {{totalPriceValue}}
      <app-tooltip
        [tooltip]="feeDetailsTooltip"
        [showToolTipAsHtml]="true"
        triggers="click :keydown.escape :keydown.tab"
        allytmln="Service Fee Details">
        <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
      </app-tooltip>
    </td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #groundedColumn>
  @if (groundedValue | async) {
    <td>
      <em class="allycon-checkmark" aria-hidden="true"></em>
    </td>
  } @else {
    <td>{{noValueIndicator}}</td>
  }
</ng-template>

<ng-template #mobileHighestOfferField>
  <div class="mobile-label">{{listViewTableTranslations.textHighestOffer}}</div>
  <ng-container [ngTemplateOutlet]="highestOfferColumn"></ng-container>
</ng-template>

<ng-template #mobileHistoricalHighField>
  <div class="mobile-label"
    data-test-id="app-list-view-inventory-item-historical-high-mobile-label">
      {{vehicleCardTranslations.textHistoricalHigh}}
  </div>
  <ng-container [ngTemplateOutlet]="historicalHighColumn"></ng-container>
</ng-template>

<ng-template #mobileOpeningPriceField>
  <div class="mobile-label">{{listViewTableTranslations.textOpeningPrice}}</div>
  <ng-container [ngTemplateOutlet]="openingPriceColumn"></ng-container>
</ng-template>

<ng-template #mobileSalePriceField>
  <div class="mobile-label">{{listViewTableTranslations.textSalePrice}}</div>
  <ng-container [ngTemplateOutlet]="salePriceColumn"></ng-container>
</ng-template>

<ng-template #mobileBuyNowField>
  <div class="mobile-label">{{listViewTableTranslations.textBuyNow}}</div>
  <ng-container [ngTemplateOutlet]="buyNowColumn"></ng-container>
</ng-template>

<ng-template #mobileSaleFeeField>
  <div class="mobile-label">{{listViewTableTranslations.textSaleFee}}</div>
  <ng-container [ngTemplateOutlet]="saleFeeColumn"></ng-container>
</ng-template>


<ng-template #inServiceVehicleButtons>
  @if (isInServiceVehicle) {
    <button class="btn btn-link text-primary decision-link" role="button"
      (click)="showEditListingGroundModal('EDITLISTING')" [attr.id]=listViewTableTranslations.textEditListingGround
      [attr.data-track-name]="editListingGroundDataTrack" data-track-trigger="modal" data-track-elem="editListingGroundDataTrack" allytmln="listEditListingGround"
      [attr.aria-label]=listViewTableTranslations.textEditListingGround [appTrackButton]=listViewTableTranslations.textEditListingGround
      tabindex="0">
      {{ listViewTableTranslations.textEditListingGround }}
    </button>
    <br>
      @if (isReserved) {
        @if(isChangeReservedDealershipEnabled) {
          <button class="btn btn-link text-primary decision-link" role="button"
            (click)="openModal(makeReserveModal, analyticsObject.changeReserved)" [attr.id]=listViewTableTranslations.textChangeReservedDealership
            [attr.data-track-name]="changeReservedDealershipDataTrack" data-track-trigger="modal" data-track-elem="changeReservedDealershipDataTrack" allytmln="listChangeReservedDealership"
            allytm-click-tagged="false"
            [attr.aria-label]=listViewTableTranslations.textChangeReservedDealership [appTrackButton]=listViewTableTranslations.textChangeReservedDealership
            tabindex="0">
            {{ listViewTableTranslations.textChangeReservedDealership | titlecase }}
          </button>
          <br>
          }
          <button class="btn btn-link text-primary decision-link" role="button"
            (click)="openModal(makeUnreserveModal, analyticsObject.unreserve)" [attr.id]=listViewTableTranslations.textUnreserve
            [attr.data-track-name]="unreserveDataTrack" data-track-trigger="modal" data-track-elem="unreserveDataTrack" allytmln="listUnreserve"
            allytm-click-tagged="false"
            [attr.aria-label]=listViewTableTranslations.textUnreserve [appTrackButton]=listViewTableTranslations.textUnreserve
            tabindex="0">
            {{ listViewTableTranslations.textUnreserve | titlecase }}
          </button>
        }
        @else {
        <button class="btn btn-link text-primary decision-link" role="button"
          (click)="openModal(makeReserveModal, analyticsObject.reserve)" [attr.id]=reserveStatus
          [attr.data-track-name]="reserveDataTrack" data-track-trigger="modal" data-track-elem="reserveDataTrack" allytmln="listReserve"
          allytm-click-tagged="false"
          [attr.aria-label]=reserveStatus [appTrackButton]=reserveStatus
          tabindex="0">
          {{ reserveStatus | titlecase }}
        </button>
      }
    }
  </ng-template>

  <ng-template #listViewActiveAuctionButtons>
    @if (showOfferActionButton('ACCEPT')) {
      <button class="btn btn-link text-primary decision-link" role="button"
        (click)="showMultiActionModal('ACCEPT')" [attr.id]=listViewTableTranslations.textAccept
        [attr.data-track-name]="acceptDataTrack" data-track-trigger="modal" data-track-elem="acceptDataTrack" allytmln="listAccept"
        [attr.aria-label]=listViewTableTranslations.textAccept [appTrackButton]=listViewTableTranslations.textAccept
        tabindex="0">
        {{ listViewTableTranslations.textAccept | titlecase }}
      </button>
    }
    <br>
      @if (showOfferActionButton('COUNTER')) {
        <button class="btn btn-link text-primary decision-link" role="button"
          (click)="showMultiActionModal('COUNTER')" [attr.id]=listViewTableTranslations.textCounter
          [attr.data-track-name]="counterDataTrack" data-track-trigger="modal" data-track-elem="counterDataTrack" allytmln="listCounter"
          [attr.aria-label]=listViewTableTranslations.textCounter [appTrackButton]=listViewTableTranslations.textCounter
          tabindex="0">
          {{ listViewTableTranslations.textCounter | titlecase }}
        </button>
      }
      <br>
        @if (showOfferActionButton('DECLINE')) {
          <button class="btn btn-link text-primary decision-link" role="button"
            (click)="showMultiActionModal('DECLINE')" [attr.id]=listViewTableTranslations.textDecline
            [attr.data-track-name]="declineDataTrack" data-track-trigger="modal" data-track-elem="declineDataTrack" allytmln="listDecline"
            [attr.aria-label]=listViewTableTranslations.textDecline [appTrackButton]=listViewTableTranslations.textDecline
            tabindex="0">
            {{ listViewTableTranslations.textDecline | titlecase }}
          </button>
        }

        @if (showOfferActionButton('WITHDRAW')) {
          <button class="btn btn-link text-primary decision-link"
            (click)="showMultiActionModal('WITHDRAW')" [attr.id]=listViewTableTranslations.textWithdraw
            appTrackButton="Withdraw" [attr.id]=listViewTableTranslations.textWithdraw
            [attr.data-track-name]="withdrawDataTrack"
            data-track-trigger="modal" data-track-elem="withdrawDataTrack" allytmln="listWithdraw"
            [attr.aria-label]=listViewTableTranslations.textWithdraw
            [appTrackButton]=listViewTableTranslations.textWithdraw tabindex="0">
            {{ listViewTableTranslations.textWithdraw | titlecase }}
          </button>
        }

        @if (showOfferActionButton('REVIVE')) {
          <button class="btn btn-link text-primary decision-link"
            (click)="showMultiActionModal('REVIVE')" [attr.id]=listViewTableTranslations.textRevive
            appTrackButton="Revive" [attr.id]=listViewTableTranslations.textRevive [attr.data-track-name]="revive"
            data-track-trigger="modal" data-track-elem="revive" allytmln="listRevive" [attr.aria-label]=listViewTableTranslations.textRevive
            [appTrackButton]=listViewTableTranslations.textRevive tabindex="0">
            {{ listViewTableTranslations.textRevive | titlecase }}
          </button>
        }

        <button
          class="btn btn-link text-primary decision-link" role="button"
          data-track-elem="button"
          [attr.aria-label]="listViewTableTranslations.textOffers + title"
          [attr.id]=listViewTableTranslations.textOffers
          [attr.data-track-name]="'Offers-' + auctionItemSell$().inventoryItemUuid"
          allytmln="listOffers"
          routerLink="/inventory/{{ auctionItemSell$().inventoryItemUuid }}/offers">
          {{ listViewTableTranslations.textOffers | titlecase }}
        </button>
      </ng-template>

      <ng-template #listViewHistoryButton>
        <button
          (click)="showPurchaseOfferHistoryModal()"
          class="btn btn-link text-primary decision-link"
          data-track-elem="button"
          [attr.aria-label]="listViewTableTranslations.textViewHistory + title"
          [attr.data-track-name]="'View History-' + auctionItemSell$()?.inventoryItemUuid"
          allytmln="listViewHistory">
          {{ listViewTableTranslations.textViewHistory | titlecase }}
        </button>
      </ng-template>

      <ng-template #listViewPostingHistoryButton>
        @if (showListViewPostingHistoryButton) {
          <button
            (click)="showPostingHistoryModal()"
            class="btn btn-link text-primary decision-link"
            data-track-elem="button"
            [attr.aria-label]="listViewTableTranslations.textViewPostingHistory + title"
            [attr.data-track-name]="'View Posting History-' + auctionItemSell$()?.inventoryItemUuid"
            allytmln="listViewPostingHistory">
            {{ listViewTableTranslations.textViewPostingHistory | titlecase }}
          </button>
        }
      </ng-template>

      <ng-template #listViewEditButton>
        @if (isHoldActionsEnabled) {
          <button
            class="btn btn-link text-primary decision-link"
            data-track-elem="button"
            [attr.aria-label]="listViewTableTranslations.textEdit + title"
            [attr.data-track-name]="'Edit-' + auctionItemSell$().inventoryItemUuid"
            [routerLink]="isEditDisabled ? null : '/inventory/edit/' + auctionItemSell$()?.inventoryItemUuid"
            (click)="updateBackToInventory()"
            allytmln="listEdit">
            {{ listViewTableTranslations.textEdit | titlecase }}
          </button>
        }
      </ng-template>

      <ng-template #listViewRepostButton>
        @if (showListViewRepostButton) {
          <button
            class="btn btn-link text-primary decision-link" role="button"
            data-track-elem="button"
            [attr.aria-label]="listViewTableTranslations.textRepost + title"
            [attr.data-track-name]="'Repost-' + auctionItemSell$().inventoryItemUuid"
            (click)="onClickRepost($event, auctionItemSell$()?.itemDetail.vin)"
            allytmln="listRepost">
            {{ listViewTableTranslations.textRepost | titlecase }}
          </button>
        }
      </ng-template>

      <app-edit-listing-ground-modal (groundedValueChanged)="groundedValueChanged($event)"></app-edit-listing-ground-modal>

      <ng-template #messageModal>
        <app-action-list-message-modal
          (close)="onModalClose()"
          [messages$]="modalMessage">
        </app-action-list-message-modal>
      </ng-template>

      <ng-template #makeReserveModal>
        <app-make-reserve-modal
          [isReserved$]="isReserved"
          (close)="onModalClose()"
          (message)="onModalMessage($event, messageModal)">
        </app-make-reserve-modal>
      </ng-template>

      <ng-template #makeUnreserveModal>
        <app-make-unreserve-modal
          [auctionItem]=auctionItemSell$()
          (close)="onModalClose()"
          (message)="onModalMessage($event, messageModal)">
        </app-make-unreserve-modal>
      </ng-template>

      <app-shared-list-multi-action-modal [userType]="userType" (modalEvent)="createBanners($event)"></app-shared-list-multi-action-modal>

      <app-purchase-offer-history-modal
        [auctionItemSell$]="auctionItemSell$()"
        [saleDate$]="saleDateTime"
        [salePrice$]="auctionItemSell$().salePrice"
        [vehicleTitle$]="title">
      </app-purchase-offer-history-modal>

      <app-posting-history-modal [auctionItemUuid]="auctionItemSell$().vehicleUuid"></app-posting-history-modal>

